import React, { useContext } from 'react';
import { AuthContext } from '../../../../../../contexts/AuthContext';
import { formatNumber } from '../../../../../../utils/utils';
import ButtonTableAction from '../../../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../../../components/default/DefaultDataTable';
import {
    WarehouseExtraService,
    WarehouseExtraServiceFilters,
} from '../../../../../../app/models/WareHouseQuoteExtraService';

interface Props {
    warehouseQuoteExtraServices: WarehouseExtraService[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    filter: WarehouseExtraServiceFilters;
    setFilter: (filter: WarehouseExtraServiceFilters) => void;
    isShow?: boolean;
    paginationRowsPerPageOptions?: any[];
}

const WarehouseQuoteExtraServiceDataTable = ({
    warehouseQuoteExtraServices,
    totalRows,
    isShow = false,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter
}: Props) => {
    const { auth } = useContext(AuthContext);

    const columns = [


        {
            name: 'Servicio',
            selector: (row: WarehouseExtraService) => row.services,
            sortable: true,
            sortField: 'service',
            cell: (row: WarehouseExtraService) => <span>{row.service}</span>
        },
        {
            name: 'Tarifa',
            selector: (row: WarehouseExtraService) => row.price,
            sortable: true,
            sortField: 'rate',
            cell: (row: WarehouseExtraService) => formatNumber(row.price)
        },
        {
            name: 'Moneda Tarifa',
            selector: (row: WarehouseExtraService) => row.currency,
            sortable: true,
            sortField: 'currency',
            cell: (row: WarehouseExtraService) => <span>{row.currency}</span>
        },
        {
            name: 'Unidad',
            selector: (row: WarehouseExtraService) => row.unit,
            sortable: true,
            sortField: 'unit',
            cell: (row: WarehouseExtraService) => <span>{row.unit}</span>
        },
        {
            name: 'Acciones',
            cell: (row: WarehouseExtraService) => (
                <div className="d-flex gap-1">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon="mdi mdi-eye"
                            colorIcon="text-info"
                            title="Ver"
                        />
                    )}
                    {!isShow && edit && (
                        <ButtonTableAction
                        callbackFunction={() => edit(row.id ?? -1)}
                        classIcon="mdi mdi-pencil"
                        colorIcon="text-warning"
                        title="Editar"
                        />
                    )}
                    {!isShow && destroy && (
                        <ButtonTableAction
                        callbackFunction={() => destroy(row.id ?? -1)}
                        classIcon="mdi mdi-delete"
                        colorIcon="text-danger"
                        title="Eliminar"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row">
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={warehouseQuoteExtraServices}
                    progressPending={loading}
                    filter={filter}
                    setFilter={setFilter}
                    paginationTotalRows={totalRows}
                />
            </div>
        </div>
    );
};

export default WarehouseQuoteExtraServiceDataTable;
